import React from 'react';
import { TableColumns } from '@bexs/dollar-hooks/useTable/types';
import { FormattedStatement } from 'store/ducks/statements/types';
import CustomTitleAndSubtitle from 'components/CustomTitleAndSubtitle';
import OperationIcon from './sections/OperationIcon';

export const bexsBankName = '144 - BEXS BANCO DE CÂMBIO S/A';
export const ITEMS_PER_PAGE = 30;

export const tableColumns: TableColumns<FormattedStatement> = [
  {
    name: '',
    dataKey: 'transactionIndicator',
    render: (value: unknown, statement) => (
      <OperationIcon
        isRevert={statement.Description === 'WITHDRAW(REVERTED)'}
        amount={statement.Amount}
      />
    ),
  },
  {
    name: 'Date',
    dataKey: 'Date',
    render: (date: string, statement) => {
      return (
        <CustomTitleAndSubtitle
          title={statement.Date}
          subtitle={statement.Hour}
        />
      );
    },
  },
  {
    name: 'Description',
    dataKey: 'Description',
    render: (value: unknown, statement) => {
      const displayBank =
        statement.Type === 'BUYING_CURRENCY' ||
        statement.Type === 'SELLING_CURRENCY'
          ? bexsBankName
          : statement.Type === 'WITHDRAW'
          ? statement.ReceiverBankName
          : statement.PayerBankName;
      return (
        <CustomTitleAndSubtitle
          title={statement.DescriptionLabel}
          subtitle={`${statement.FullName} / ${displayBank}`}
        />
      );
    },
  },
  {
    name: 'Transfer Type',
    dataKey: 'TransferTypeFormatted',
  },
  {
    name: 'Amount',
    dataKey: 'AmountFormatted',
  },
  {
    name: 'Balance',
    dataKey: 'BalanceFormatted',
  },
];
